import type { Asset, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { AssetTypeIcon } from "../../../components/Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../../../components/IndexLabels/AssetIndexLabel"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type AssetMentionListProps = MentionListRootProps<Stored<Asset>>

export const AssetMentionList = memo(
	forwardRef<MentionListRef<Stored<Asset>>, AssetMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<Asset>> ref={ref} {...props}>
				{items.map((asset) => (
					<MentionListItem<Stored<Asset>> item={asset} key={asset.uuid}>
						<AssetTypeIcon assetTypeId={asset.asset_type} inline />
						<AssetIndexLabel assetId={asset.uuid} />
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
AssetMentionList.displayName = "AssetMentionList"
